import React from 'react';
import PlateGrid from '../components/PlateGrid';

const Home: React.FC = () => {
  return (
    <div>
      <PlateGrid />
    </div>
  );
};

export default Home;
